import { apiCall } from '@/lib/api-client';

/** The knowledge base and the closing note. Neither carries a query key that
 *  needs the case: the KB is the same for everyone, the briefing belongs to
 *  the case's own cache. */

export type KbCategoria = 'faq' | 'momentos' | 'operativo' | 'referencia';

export interface KbArticle {
  id: string;
  slug: string;
  titulo: string;
  categoria: KbCategoria;
  bodyEs: string;
  bodyEn: string | null;
  keywords: string;
  fuente: string;
  active: boolean;
  updatedAt: string;
}

export const kbApi = {
  /** Navigator-side search. Active articles only. */
  search: (q?: string, categoria?: string) => {
    const p = new URLSearchParams();
    if (q) p.set('q', q);
    if (categoria) p.set('categoria', categoria);
    const qs = p.toString();
    return apiCall<KbArticle[]>(`/navigator/kb${qs ? `?${qs}` : ''}`);
  },
  /** Admin-side: includes the deactivated ones, which is the point. */
  listAll: () => apiCall<KbArticle[]>('/admin/navigation/kb'),
  create: (body: {
    slug: string;
    titulo: string;
    categoria: KbCategoria;
    bodyEs: string;
    bodyEn?: string | null;
    keywords?: string;
    fuente?: string;
  }) => apiCall<KbArticle>('/admin/navigation/kb', { method: 'POST', body }),
  update: (
    id: string,
    body: Partial<{
      titulo: string;
      categoria: KbCategoria;
      bodyEs: string;
      bodyEn: string | null;
      keywords: string;
      fuente: string;
      active: boolean;
    }>,
  ) => apiCall<KbArticle>(`/admin/navigation/kb/${id}`, { method: 'PATCH', body }),
};

export const briefingApi = {
  generate: (caseId: string) =>
    apiCall<{ noteId: string; body: string; regenerated: boolean }>(
      `/navigator/cases/${caseId}/briefing`,
      { method: 'POST' },
    ),
};

export const KB_KEYS = {
  search: (q: string, cat: string) => ['navigator', 'kb', q, cat] as const,
  admin: ['admin', 'navigation', 'kb'] as const,
};
